import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthProvider, logout } from '@modeso/aumico-lib-users-fe';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ofType } from '@ngrx/effects';
import { ActionsSubject } from '@ngrx/store';
import Debug from 'debug';
import { LocalStorageService } from '../../../../../aumico-lib-core-fe/src/lib/services/localStorage.service';
import { Paths } from '../../enums/paths.enum';
import { ResetStoreService } from '../../shared/services/resetStore.service';

const debug = Debug('aumico:aumico-project-admin:LogoutPage');
@UntilDestroy()
@Component({
    selector: 'app-page-logout',
    template: '',
})
export class LogoutPage implements OnInit {
    constructor(
        private router: Router,
        private localStorageService: LocalStorageService,
        private authProvider: AuthProvider,
        private resetStoreService: ResetStoreService,
        private actionsListener$: ActionsSubject,
    ) {}

    ngOnInit() {
        debug('Logout');
        this.authProvider.logout();
        this.actionsListener$
            .pipe(ofType(logout.success), untilDestroyed(this))
            .subscribe(() => this.onLogoutSuccessfully());
    }

    private onLogoutSuccessfully(): void {
        debug('Logout successfully');
        this.resetStoreService.resetAllStores();
        this.localStorageService.clearAllExceptLanguage();
        this.router.navigate([`./${this.localStorageService.getCurrentLanguage()}/${Paths.AUTH}/${Paths.LOGIN}`]);
    }
}
